"use client";

import { useEffect } from "react";

export default function DemosScrollReset() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Disable browser automatic scroll restoration to prevent landing midway down on reload
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }

      // Check if there is no URL hash (e.g. #section) - always start at top of page
      if (!window.location.hash) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
    }
  }, []);

  return null;
}
